import React from "react";
import PropertyBase from "./PropertyBase";
import { LayoutOrientations } from "../../globals";
import Panel from "../layout/Panel";
import Spacer from "../layout/Spacer";
import { EyeIcon, EyeIconOff } from '../Iconset';
import AnalyticsManager from "../../classes/AnalyticsManager";

/**
 * defines a checkbox input for boolean values
 * @export
 * @param {{
 * value: Boolean,
 * multivalues: Boolean,
 * disabled: Boolean,
 * onChangeCallback: (newValue: Boolean),
 * onCommitCallback: (),
 * "data-name": String
 * }} props this property expects and can use these special props:
 * - value: the current value of the checkbox
 * - multivalues: determines whether to draw the checkbox normally, or with a mark indicating the field is shared between many different values *optional*
 * - disabled: if 'true', the checkbox will not be interactable, and will serve as read-only value display
 * - onChangeCallback: a callback function that will be executed whenever the value of the internal checkbox changes, with the new value as the passed parameter *optional*
 * - onCommitCallback: a callback function that will be executed when the internal field loses focus, passing no parameters *optional*
 * - "data-name": used for automation purposes to specifically identify this property. *defaults to "-bool-property". optional*
 * @returns a labeled checkbox
 */
export default function IconBoolProperty(props)
{
	const dataName = (props["data-name"] ? props["data-name"] + "-" : "") + "-bool-property";
	var value = props.value;

	if(props.falseValue)
	{
		if(props.value === props.falseValue)
			value = false;
		else
			value = true;
	}

	return (
		<PropertyBase {...props}
			data-name={dataName + "-root"}
			decoratorMode={props.decoratorMode}
			style={props.decoratorMode ? { marginTop: '-8px', width: '24px', display: 'inline-block' } : {}}
			className={!props.decoratorMode ? "standaloneProperty" : "decoratorProperty"}
		>
			<Panel orientation={LayoutOrientations.Horizontal}>
				<Spacer stretchTo={{ x: '100%' }}/>
				<div
					data-name={dataName + "-input"}
					className={"toggleIconField"}
					//style={props.decoratorMode ? {width:'20px', left:'-10px', display:'inline-block'} : {}}
					onClick={(e)=>
					{
						AnalyticsManager.managedEvent('propertyChanged', 'propertyId', e.target.dataset.name)

						if (props.onCommitCallback)
						{
							if(props.falseValue)
							{
								if(value === 'true' || value === true)
								{
									props.onCommitCallback(props.falseValue);
								}
								else
								{
									props.onCommitCallback(props.trueValue);
								}
							}
							else
							{
								props.onCommitCallback(!value);
							}
						}
						else if (props.onChangeCallback)
						{
							if(props.falseValue)
							{
								if(value === 'true' || value === true)
								{
									props.onChangeCallback(props.falseValue);
								}
								else
								{
									props.onChangeCallback(props.trueValue);
								}
							}
							else
							{
								props.onChangeCallback(!value);
							}
						}
					}}
				>
					{
						value === 'true' || value === true ?
							props.checkedIcon ? props.checkedIcon : <EyeIcon/>
							:
							props.uncheckedIcon ? props.uncheckedIcon : <EyeIconOff/>
					}
				</div>
			</Panel>
		</PropertyBase>
	);
}
